import { always, apiFetch } from 'utils'

function queryForGet (page, filters) {
  let i = 0
  const typesQuery = {}
  for (var prop in filters.types) {
    if (filters.types[prop]) {
      typesQuery[`types[${i}]`] = prop
      i++
    }
  }

  return {
    page,
    sort: filters.sort,
    search: filters.search,
    faculty: filters.faculty,
    department: filters.department,
    school: filters.school,
    tag: filters.tag,
    ...typesQuery
  }
}

export function get (page, filters) {
  return apiFetch('/project', queryForGet(page, filters))
  .catch(always([]))
}

export function getSingle (id) {
  return apiFetch(`/project/${id}`)
  .catch(always([]))
}



// WEBPACK FOOTER //
// ./resources/assets/js/transport/project.js